// --------------------------------------------------------------------- Styles
import 'normalize.css'
import 'primeflex/themes/primeone-light.css'
import 'primeflex/primeflex.css'
import 'typeface-inter'
import 'typeface-raleway'
import '@/styles/style.css'

// ------------------------------------------------------------------- Core Vue
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from '@/App.vue'
import router from '@/router'

const app = createApp(App)
app.use(createPinia())
app.use(router)

// ---------------------------------------------------- Error Tracking (Sentry)
import * as Sentry from '@sentry/vue'

const environment = import.meta.env.VITE_ROTHIER_ENVIRONMENT
if (environment === 'production') {
  Sentry.init({
    app,
    dsn: 'https://a5d3d668d56af928cef2f8571370289b@o4509334586261504.ingest.de.sentry.io/4509334589866064',
    sendDefaultPii: true,
  })
}

// ---------------------------------------------------------------- FontAwesome
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(fas)
library.add(fab)
dom.watch()

// ------------------------------------------------------------------- Primevue
import PrimeVue from 'primevue/config'
import Nora from '@primeuix/themes/nora'
import { definePreset } from '@primeuix/themes'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import Ripple from 'primevue/ripple'
import Tooltip from 'primevue/tooltip'

const customPreset = definePreset(Nora, {
  semantic: {
    primary: {
      50: '#f0f0f0',
      100: '#d9d9d9',
      200: '#b3b3b3',
      300: '#8c8c8c',
      400: '#666666',
      500: '#333333',
      600: '#2b2b2b',
      700: '#212121',
      800: '#171717',
      900: '#0d0d0d',
      950: '#050505',
    },
  },
})

app.use(PrimeVue, {
  theme: {
    preset: customPreset,
    options: {
      prefix: 'p-neutral',
      darkModeSelector: false,
    },
  },
})

app.use(ToastService)
app.use(ConfirmationService)
app.directive('tooltip', Tooltip)
app.directive('ripple', Ripple)

// ---------------------------------------------------------------------- Konva
import VueKonva from 'vue-konva'

app.use(VueKonva)

// ---------------------------------------------------------------------- Mount
app.mount('#app')
